export const ALL_REWARDS_ENDPOINTS = {
  GET_ALL_OPEN_NOMINATIONS: 'api/v1/nomination/configuration/open-nomination',
  GET_ALL_SUBMITTED_NOMINATION: 'api/v1/nomination/configuration/submitted-nomination',
  GET_ELIGIBLE_EMPLOYEES: 'api/v1/nomination/configuration/employees/',
  NOMINATE_EMPLOYEE: 'api/v1/nomination',
  GET_ALL_ACTIVITY: 'api/v1/badge/assignments/admin/all-activity',
  GET_ALL_REWARDS: 'api/v1/badge/assignments/admin/all-rewards'
}